import { render, staticRenderFns } from "./CreateAssetsCard.vue?vue&type=template&id=46a7ce7f&scoped=true&"
import script from "./CreateAssetsCard.vue?vue&type=script&lang=js&"
export * from "./CreateAssetsCard.vue?vue&type=script&lang=js&"
import style0 from "./CreateAssetsCard.vue?vue&type=style&index=0&id=46a7ce7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a7ce7f",
  null
  
)

export default component.exports